import React from 'react';
import { Segment, Loader, Dimmer } from 'semantic-ui-react';

// const LoaderExampleInlineCentered = () => <Loader active inline='centered' size='large' >Loading</Loader>
const LoaderExampleInlineCentered = () => (
    <React.Fragment>
        <div className='w-full h-full bg-slate-100 rounded-2xl'>
            <div className="cube-wrapper">
                <div className="cube-folding">
                    <span className="leaf1"></span>
                    <span className="leaf2"></span>
                    <span className="leaf3"></span>
                    <span className="leaf4"></span>
                </div>
                <span className="loading" data-name="Loading">
                    Loading
                </span>
            </div>
        </div>
    </React.Fragment>
);
export default LoaderExampleInlineCentered;



// WEBPACK FOOTER //
// ./src/app/components/features/share/loadingInline.js